export const GET_STUDENT_WORKSMART_DATA_QUERY = `
  query getStudentWorksmartData {
    getStudentWorksmartData {
      userId
      teamId
      companyId
    }
  }
`;

export const GET_STUDENT_WORKSMART_DATA_QUERY_DEPRECATED = `
  query getStudentWorksmartData($studentId: String!) {
    getStudentWorksmartData(studentId: $studentId) {
      userId
      teamId
      companyId
    }
  }
`;
